export enum KdfType {
  PBKDF2_SHA256 = 0,
  Argon2id = 1,
}
